import { BreadcrumbProps, Flex, Paper, Span } from "@goodfill/ui-components";
import { useMemo } from "react";
import { iconUrlByTicker } from "../../../assets/tickerAssetsIndex";
import { FavorBond } from "../../bonds/detail/FavorBond";
import { PricedBond } from "../../bonds/PricedBond";
import { BreadcrumbNavigation } from "../../BreadcrumbNavigation";
import { CreateOrderBondData } from "./form/CreateOrderBondData";
import "./OrderFormLayout.scss";

interface Props {
  pricedBond: PricedBond;
  children: React.ReactNode;
  breadcrumbItems?: BreadcrumbProps["items"];
}

export const OrderFormLayout = ({ children, pricedBond, breadcrumbItems = [] }: Props) => {
  const issuerName = pricedBond.issuerName;

  const iconImageUrl = useMemo(() => {
    const ticker = pricedBond.issuerTicker;
    return iconUrlByTicker(ticker);
  }, [pricedBond]);
  return (
    <>
      <BreadcrumbNavigation items={breadcrumbItems} />

      <Flex direction="col" gap={6} className="mb-24">
        <Paper>
          <Flex direction="row" items="center" justify="between" className="px-20 py-6 order-screen" gap={2}>
            <div className="flex items-center gap-3">
              {iconImageUrl ? <img src={iconImageUrl} style={{ height: "54px", width: "54px" }} alt="" /> : null}
              <Span primary={true} font="semibold" size="xl" className=" break-word whitespace-unset-important">
                {issuerName}
              </Span>
            </div>

            <Flex direction="row" items="center" gap={4} justify="end">
              <Span primary={true} size="xl">
                <FavorBond pricedBond={pricedBond} size={30} className="favor-star" />
              </Span>
            </Flex>
          </Flex>
        </Paper>
        <Paper>
          <Flex justify="center" className="px-20 order-screen">
            <div>
              <Flex direction="col" gap={6} verticalMargin={6} justify="center">
                <CreateOrderBondData pricedBond={pricedBond} />
                {children}
              </Flex>
            </div>
          </Flex>
        </Paper>
      </Flex>
    </>
  );
};
